/* eslint-disable jsx-a11y/anchor-is-valid */
import './index.less';
import { Button, Space, Table, Spin, Modal, message, Popover } from 'antd';
// import EmptyIcon from '@/assets/empty.png'; // 无数据状态的背景图
import UpdateAuCode from './auCodeSet';
import AlertDisable from './alertDisable';
import { useState, useEffect } from 'react';
import { EmptyFileColor } from 'patternx-svg';
// 导入接口
import * as api from '@/services/enterprise';
import { toTree } from '@/utils/utils';

const ComponyList = (props: any) => {
  const { handleAuCodeListCancel, enterpriseWorkspaceId, setOpenCreateAuthorization, units } =
    props;

  useEffect(() => {
    // 页面初始化
    getPerList();
    getAuCodeList();
  }, []);

  // const [plainOptions, setPlainOptions] = useState([]);
  const [projectApplicationTree, setProjectApplicationTree] = useState<any[]>([]);
  const [projectApplicationList, setrojectApplicationList] = useState<any[]>([]);

  // let auCodeArray: any = [];
  // const [defaultCheckedList, setDefaultCheckedList] = useState(['']);
  // const auCodeArray = useRef([])
  // const [aucodeArray,setAucodeArray] = useState([])
  const getPerList = async () => {
    const res = await api.getPermissionsList('2');
    if (res.code === 200 && res.success) {
      const lists = res?.data?.details || [];
      setrojectApplicationList(lists);
    } else {
      message.error('获取项目级权限列表失败');
    }
  };

  const onEditCode = async (record: any) => {
    setAuCode(record.code);
    setOpenUpdateAuCode(true);
    setAuCodeInfo(record);
    //默认选中项
    const defaultCheckedList = record?.projectApplications?.map((item: any) => {
      return item.code;
    });
    setUpdateApplications(defaultCheckedList);
    let lists = projectApplicationList;
    if (lists?.length === 0) {
      const res = await api.getPermissionsList('2');
      if (res.code === 200 && res.success) {
        lists = res?.data?.details || [];
      }
    }
    const newDatas = toTree(
      lists,
      {
        id: 'id',
        parentId: 'parentId',
      },
      (item: any) => {
        //项目管理 不可修改
        if (item?.code === 'project') {
          item.disabled = true;
        }
        //默认选中
        if (defaultCheckedList?.includes(item?.code)) {
          item.checked = true;
        } else {
          item.checked = false;
        }
        item.key = item.code;
      },
    );
    setProjectApplicationTree(newDatas);
  };

  // 表格参数
  // 表格表头-纵向数据设置
  const columns: any = [
    {
      title: '授权码',
      dataIndex: 'code',
      key: 'code',
      width: 120,
      fixed: 'left',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (_: any, record: any) => {
        // console.log('授权码状态', _, record);
        if (record.status === 'unBind') {
          return (
            <Space>
              <div
                style={{
                  color: '#039855',
                  background: '#d1fadf',
                  lineHeight: '24px',
                  width: '52px',
                  height: '24px',
                  textAlign: 'center',
                }}
              >
                未绑定
              </div>
            </Space>
          );
        } else if (record.status === 'bind') {
          return (
            <Space>
              <div
                style={{
                  color: '#1570ef',
                  background: '#d1e9ff',
                  lineHeight: '24px',
                  width: '52px',
                  height: '24px',
                  textAlign: 'center',
                }}
              >
                已绑定
              </div>
            </Space>
          );
        } else if (record.status === 'disable') {
          return (
            <Space>
              <div
                style={{
                  color: '#5f6173',
                  background: '#f2f3f5',
                  lineHeight: '24px',
                  width: '52px',
                  height: '24px',
                  textAlign: 'center',
                }}
              >
                已停用
              </div>
            </Space>
          );
        }
      },
    },
    {
      title: '生成时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 180,
    },
    {
      title: '有效期',
      dataIndex: 'expiredDuration',
      key: 'expiredDuration',
      width: 120,
      render: (_: any, record: any) => (
        // console.log('授权码有效期', _, record),
        <Space>
          <div>
            {_}
            {record?.timeUnite === 'month' ? '月' : '天'}
          </div>
        </Space>
      ),
    },
    {
      title: '绑定项目',
      dataIndex: 'bindProjectName',
      key: 'bindProjectName',
      // width: 200,
      render: (_: any, record: any) => <Space>{_ === '' ? <div>-</div> : _}</Space>,
    },
    {
      title: '项目级应用',
      dataIndex: 'projectApplicationtree',
      key: 'projectApplicationtree',
      width: 140,
      render: (_: any, record: any) => (
        // console.log('授权码项目级应用', _, record),
        <Space>
          <Popover
            content={
              <div>
                {_.length > 0 &&
                  _.map((item: any) => {
                    // console.log('授权码项目级应用123', item);
                    return (
                      <div style={{ marginBottom: '4px', color: '#868b9c', maxWidth: '200px' }}>
                        {item.name || ''}
                        {item?.children?.length > 0 ? '：' : ''}
                        {item?.children?.length > 0 && (
                          <span>
                            {item?.children?.map((child: any) => (
                              <span style={{ marginRight: '8px' }} key={child.code}>
                                {child?.name || ''}
                              </span>
                            ))}
                          </span>
                        )}
                      </div>
                    );
                  })}
              </div>
            }
            title="项目级应用"
            trigger="hover"
          >
            <div
              style={{
                color: '#5f6173',
                background: '#f2f3f5',
                lineHeight: '24px',
                width: '52px',
                height: '24px',
                textAlign: 'center',
              }}
            >
              {_?.length || 0}项
            </div>
          </Popover>
        </Space>
      ),
    },
    {
      title: '绑定时间',
      dataIndex: 'bindedTime',
      key: 'bindedTime',
      width: 180,
    },
    {
      title: '到期时间',
      dataIndex: 'expiredTime',
      key: 'expiredTime',
      width: 180,
    },
    {
      title: '操作',
      key: 'action',
      // width: 140,
      fixed: 'right',
      render: (_: any, record: any) => {
        // console.log(record, _, 'render');
        const ableCode = record.status;
        if (ableCode === 'unBind') {
          return (
            <Space size="middle">
              <a onClick={() => onEditCode(record)}>编辑</a>
              <Button
                type="link"
                style={{ color: '#F04438' }}
                onClick={() => {
                  auCodeDisabled();
                  setAuCode(record.code);
                }}
              >
                停用
              </Button>
            </Space>
          );
        } else if (ableCode === 'bind') {
          return (
            <Space size="middle">
              <a onClick={() => onEditCode(record)}>编辑</a>
              <Button type="link" style={{ color: '#cacdd4' }} disabled>
                停用
              </Button>
            </Space>
          );
        } else {
          // 停用状态
          return (
            <Space size="middle">
              <a>-</a>
              <a> </a>
            </Space>
          );
        }
      },
    },
  ];

  // 停用授权码
  const [openAlertDisable, setOpenAlertDisable] = useState(false);
  const handleAlertOK = async () => {
    const res = await api.updateAuthorizationCode({
      authorizationCode: auCode,
      status: 'disable',
    });
    // console.log('停用授权码', res);
    if (res.code === 200 && res.success) {
      message.success('停用授权码成功');
      setOpenAlertDisable(false);
    } else {
      message.warning('授权码停用失败');
      setOpenAlertDisable(false);
    }
    getAuCodeList();
  };
  const handleAlertCancel = () => {
    setOpenAlertDisable(false);
  };
  const auCodeDisabled = () => {
    setOpenAlertDisable(true);
  };

  // 表格每行横向数据设置
  const [data, setData] = useState<any>([]);

  // 表格加载
  const [tableLoad, setTableLoad] = useState(true);

  // 表格初始化
  const getAuCodeList = async () => {
    setTableLoad(true);
    const res = await api.getAuthorizationStatus({
      enterpriseWorkspaceId: enterpriseWorkspaceId,
      pageIndex: page,
      pageSize: size,
    });

    console.log(res, '授权码列表初始化');
    if (res?.success && res.code === 200) {
      setData(
        res?.data?.details.items.map((i: any) => {
          return {
            ...i,
            key: i.bindProjectId,
            projectApplicationtree: toTree(i.projectApplications || [], {
              id: 'id',
              parentId: 'parentId',
            }),
          };
        }),
      );
      setTotal(res?.data?.details.totalItemCount);
    } else {
      message.error('获取授权码列表错误');
      setData([]);
    }
    setTableLoad(false);
  };
  const [page, setPage] = useState<number>(1); // 当前页码
  const [size, setSize] = useState<number>(10); // 每页显示数据数量
  const [total, setTotal] = useState<number>(0); // 总共数据量

  // 编辑授权码
  const [openUpdateAuCode, setOpenUpdateAuCode] = useState(false);
  const [updateDurationeNum, setUpdateDurationeNum] = useState(0);
  const [updateApplications, setUpdateApplications] = useState();
  const [auCode, setAuCode] = useState('');
  const [auCodeInfo, setAuCodeInfo] = useState();
  // 更新编辑授权码请求
  const handleUpdateAuCodeOK = async () => {
    // 接口好了之后解封
    const res = await api.updateAuthorizationCode({
      authorizationCode: auCode,
      ownProjectApplications: updateApplications,
      // expireDuration: updateDurationeNum,
      expireDuration: null,
      timeUnite: null,
    });
    console.log('编辑授权码', res);
    if (res.code === 200) {
      message.success('编辑授权码成功');
      setOpenUpdateAuCode(false);
    } else {
      message.error('编辑授权码失败');
      setOpenUpdateAuCode(false);
    }
    getAuCodeList();
  };
  const handleUpdateAuCodeCancel = () => {
    setOpenUpdateAuCode(false);
  };

  // 翻页或者切换每页数量
  useEffect(() => {
    getAuCodeList();
  }, [page, size]);

  return (
    <>
      {data.length > 0 ? (
        <Modal
          title="查看授权码"
          visible={true}
          width={1000}
          footer={null}
          onCancel={handleAuCodeListCancel}
          wrapClassName="codeListModal"
        >
          {/* <div className="wrap"> */}
          <div className="memberTable">
            <Spin spinning={tableLoad}>
              <Table
                rowKey={(record) => record.code}
                columns={columns}
                dataSource={data}
                tableLayout="fixed"
                className="memberTableTable"
                pagination={{
                  size: 'small',
                  showTotal: (total, range) => {
                    return `${range[0]}-${range[1]}条，共${total}条`;
                  },
                  showTitle: true,
                  showQuickJumper: false,
                  showSizeChanger: true,
                  total: total, // 分页总数
                  pageSize: size, // 每页数量
                  current: page, // 当前页数
                  onChange: (p, s) => {
                    console.log('翻页', { p, s });
                    setPage(p);
                    setSize(s as number);
                  },
                }}
                scroll={{ x: 1400, y: 500 }}
              />
            </Spin>
          </div>
          {/* </div> */}
        </Modal>
      ) : (
        <Modal
          title="查看授权码"
          visible={true}
          width={1000}
          footer={null}
          onCancel={handleAuCodeListCancel}
          wrapClassName="codeListModal"
        >
          <Spin spinning={tableLoad}>
            <div
              className="emptyInfo"
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              {/* <IconFont className={styles.emptyImage} type="icon-kong" /> */}
              {/* <img src={EmptyIcon} className="emptyImage" style={{ marginTop: '120px' }} /> */}
              <EmptyFileColor style={{ marginTop: '120px' }} />
              <div className="emptyBody" style={{ margin: '26px 0 12px' }}>
                没有授权码
              </div>
              <Button type="primary" className="emptyFooter" style={{ marginBottom: '160px' }}>
                <span
                  className="link"
                  onClick={() => {
                    setOpenCreateAuthorization(true);
                  }}
                  style={{ margin: '0 4px' }}
                >
                  创建授权码
                </span>
              </Button>
            </div>
          </Spin>
        </Modal>
      )}
      {openUpdateAuCode && (
        <UpdateAuCode
          setOpenUpdateAuCode={setOpenUpdateAuCode}
          handleUpdateAuCodeOK={handleUpdateAuCodeOK}
          handleUpdateAuCodeCancel={handleUpdateAuCodeCancel}
          setUpdateDurationeNum={setUpdateDurationeNum}
          setUpdateApplications={setUpdateApplications}
          auCode={auCode}
          auCodeInfo={auCodeInfo}
          // plainOptions={plainOptions}
          // defaultCheckedList={defaultCheckedList}
          datas={projectApplicationTree}
          units={units}
        />
      )}
      {openAlertDisable && (
        <AlertDisable handleAlertOK={handleAlertOK} handleAlertCancel={handleAlertCancel} />
      )}
    </>
  );
};

export default ComponyList;
